import React from 'react'

const HeroMain = (props) => {
  
  return (
    <div className='mb-4'>
      <img className='w-full h-[200px] md:h-[300px] object-cover rounded-xl' src={`../../assets/images/${props.src}`} alt="Hero img" />
    </div>
  )
}

export default HeroMain
